import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

function PrivacyPage() {
  return (
    <>
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-page-header">
          <div className="container">
            <h1 className="legal-title">Politica de Confidențialitate</h1>
            <p className="legal-updated">Ultima actualizare: Martie 2026</p>
          </div>
        </div>

        <div className="legal-content">
          <h2>1. Introducere</h2>
          <p>
            NEUROS EUROPE S.R.L. (denumit în continuare "noi", "organizatorul" sau "Brain Event") respectă 
            confidențialitatea datelor tale personale și se angajează să le protejeze conform Regulamentului 
            General privind Protecția Datelor (GDPR - UE 2016/679) și a legislației române aplicabile.
          </p>
          <p>
            Această politică explică ce date colectăm, cum le folosim, cum le protejăm și care sunt drepturile tale.
          </p>
          <h2>2. Operator de Date</h2>
          <p><strong>Denumire:</strong> NEUROS EUROPE S.R.L.</p>
          <p><strong>CUI:</strong> 50323873</p>
          <p><strong>Adresă:</strong> București, România</p>
          <p><strong>Email contact DPO:</strong> contact@brain-event.com</p>
          <p><strong>Telefon:</strong> +40 767 978 707</p>
          <h2>3. Ce Date Personale Colectăm</h2>
              
          <h3>3.1. Date de Identificare și Contact</h3>
              <ul>
                <li>Nume și prenume</li>
                <li>Adresă de email</li>
                <li>Număr de telefon</li>
                <li>Țară de reședință</li>
              </ul>

          <h3>3.2. Date de Facturare</h3>
              <ul>
                <li>Adresă de facturare</li>
                <li>Date firmă (CUI, nume companie) - opțional, dacă soliciți factură pe firmă</li>
              </ul>

          <h3>3.3. Date de Plată</h3>
          <p>
             <strong>Important:</strong> Nu stocăm datele cardului tău bancar. Plățile cu cardul sunt procesate 
                securizat prin Stripe, un furnizor de servicii de plată certificat PCI-DSS.
              </p>
              <ul>
                <li>Istoricul tranzacțiilor (data, suma, status)</li>
                <li>Metoda de plată utilizată (card/transfer bancar)</li>
              </ul>

          <h3>3.4. Date Tehnice</h3>
              <ul>
                <li>Adresă IP</li>
                <li>Tip de browser și dispozitiv</li>
                <li>Cookie-uri (vezi <a href="/politica-cookies">Politica de Cookies</a>)</li>
                <li>
                  Date despre modul în care navighezi și interacționezi cu site-ul (inclusiv pentru analiză și
                  îmbunătățirea experienței), procesate prin Microsoft Clarity atunci când accepți cookie-urile
                  relevante — vezi secțiunea 10.1 de mai jos
                </li>
              </ul>
          <h2>4. Scopul Prelucrării Datelor</h2>
              
          <h3>4.1. Procesarea Comenzilor</h3>
          <p><strong>Temei legal:</strong> Executarea contractului</p>
              <ul>
                <li>Procesarea și confirmarea comenzii tale</li>
                <li>Emiterea facturilor fiscale și proforma</li>
                <li>Comunicarea cu tine despre comanda ta</li>
              </ul>

          <h3>4.2. Organizarea Evenimentului</h3>
          <p><strong>Temei legal:</strong> Executarea contractului și interesul legitim</p>
              <ul>
                <li>Validarea biletelor la intrare</li>
                <li>Programarea sesiunilor de Brain Mapping</li>
                <li>Comunicări despre eveniment (program, locație, modificări)</li>
              </ul>

          <h3>4.3. Obligații Legale</h3>
          <p><strong>Temei legal:</strong> Conformare cu legislația</p>
              <ul>
                <li>Emiterea documentelor fiscale conform Codului Fiscal</li>
                <li>Păstrarea evidenței contabile timp de 10 ani</li>
                <li>Răspunsul la solicitările autorităților competente</li>
              </ul>

          <h3>4.4. Marketing (Opțional)</h3>
          <p><strong>Temei legal:</strong> Consimțământ explicit</p>
              <ul>
                <li>Trimiterea de newsletter cu informații despre evenimente viitoare</li>
                <li>Oferte speciale și reduceri</li>
              </ul>
          <p>
             <strong>Notă:</strong> Poți retrage oricând consimțământul pentru marketing făcând click pe 
                "Dezabonare" din orice email sau contactându-ne.
              </p>

          <h3>4.5. Analiză și îmbunătățire website (Microsoft Clarity)</h3>
          <p><strong>Temei legal:</strong> Consimțământ pentru cookie-uri și tehnologii similare (când este cazul)</p>
          <ul>
            <li>Înțelegerea modului în care vizitatorii folosesc site-urile noastre (ex. pagini vizitate, interacțiuni)</li>
            <li>Îmbunătățirea conținutului, structurii și performanței site-ului</li>
            <li>Suport pentru măsuri de securitate și limitarea abuzurilor, în măsura permisă de legislație</li>
          </ul>
          <p>
            Detalii tehnice și despre Microsoft găsești la secțiunea 10.1.
          </p>

          <h2>5. Cui Dezvăluim Datele Tale</h2>
              
          <h3>5.1. Împuterniciți (Procesatori de Date)</h3>
          <p>
             Pentru funcționarea platformei și a evenimentului, este posibil ca anumite date personale să fie
                prelucrate de <strong>împuterniciți (procesatori)</strong> care acționează exclusiv în numele
                NEUROS EUROPE S.R.L. (Brain Event), pe baza unor instrucțiuni documentate și a unor acorduri
                contractuale GDPR. Procesatorii nu pot folosi datele în alt scop decât cel indicat de noi.
              </p>
          <p>Colaborăm, printre alții, cu:</p>
              <ul>
                <li><strong>Stripe</strong> — procesare plăți cu cardul (certificat PCI-DSS)</li>
                <li><strong>FGO (Factura Global One)</strong> — emitere facturi și proforma</li>
                <li><strong>Furnizori servicii email</strong> — trimiterea confirmărilor și comunicărilor</li>
                <li><strong>Furnizori hosting</strong> — găzduirea website-ului și a platformei de bilete</li>
                <li>
                  <strong>Google</strong> — Google Analytics / Tag Manager (analiză trafic și conversii), conform{' '}
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                    Google Privacy Policy
                  </a>
                </li>
                <li>
                  <strong>Meta Platforms (Facebook)</strong> — Facebook Pixel și Conversions API (măsurare reclame),
                  conform{' '}
                  <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noopener noreferrer">
                    Meta Privacy Policy
                  </a>
                </li>
                <li>
                  <strong>Hyros</strong> — atribuire comenzi și tracking marketing (când este activ)
                </li>
                <li>
                  <strong>Microsoft Corporation</strong> — Microsoft Clarity și servicii conexe (analiză utilizare
                  site, inclusiv heatmaps și session replay), conform{' '}
                  <a href="https://privacy.microsoft.com/privacystatement" target="_blank" rel="noopener noreferrer">
                    Microsoft Privacy Statement
                  </a>
                </li>
              </ul>
          <p>
             Toți acești împuterniciți au obligația contractuală de a proteja datele tale și de a le prelucra
                doar în scopurile specificate de noi, în numele nostru.
              </p>

          <h3>5.2. Autorități și Obligații Legale</h3>
          <p>
             Putem dezvălui datele tale autorităților competente (ex: ANAF, Poliție) dacă suntem obligați legal.
              </p>

          <h3>5.3. Nu Vindem Datele Tale</h3>
          <p>
             <strong>Nu vindem, nu închiriem și nu comercializăm datele tale personale către terți.</strong>
              </p>
          <h2>6. Transfer Internațional de Date</h2>
          <p>
             Unii dintre furnizorii noștri (ex: Stripe) pot stoca datele în afara Spațiului Economic European (SEE). 
                În astfel de cazuri, ne asigurăm că:
              </p>
              <ul>
                <li>Țara destinație oferă un nivel adecvat de protecție (decizie de adecvare UE)</li>
                <li>Sunt implementate Clauze Contractuale Standard (SCC) aprobate de Comisia Europeană</li>
                <li>Furnizorul este certificat conform mecanismelor de transfer aprobate (ex: EU-US Data Privacy Framework)</li>
              </ul>
          <h2>7. Cât Timp Păstrăm Datele</h2>
              
          <h3>7.1. Date de Comandă și Facturare</h3>
          <p>
             <strong>10 ani</strong> de la data tranzacției (conform Codului Fiscal și Legii Contabilității)
              </p>

          <h3>7.2. Date de Marketing</h3>
          <p>
             <strong>Până la retragerea consimțământului</strong> sau maximum 3 ani de la ultima interacțiune
              </p>

          <h3>7.3. Date Tehnice (Logs, Cookie-uri)</h3>
          <p>
             <strong>Maximum 12 luni</strong> (conform cerințelor legale de securitate)
              </p>
          <h2>8. Drepturile Tale (GDPR)</h2>
              
          <h3>8.1. Dreptul de Acces</h3>
          <p>
             Poți solicita o copie a datelor personale pe care le deținem despre tine.
              </p>

          <h3>8.2. Dreptul de Rectificare</h3>
          <p>
             Poți solicita corectarea datelor inexacte sau incomplete.
              </p>

          <h3>8.3. Dreptul la Ștergere ("Dreptul de a fi Uitat")</h3>
          <p>
             Poți solicita ștergerea datelor tale în anumite condiții (ex: după retragerea consimțământului 
                pentru marketing). 
              </p>
          <p>
             <strong>Notă:</strong> Nu putem șterge datele necesare pentru îndeplinirea obligațiilor legale 
                (ex: facturi fiscale).
              </p>

          <h3>8.4. Dreptul la Restricționarea Prelucrării</h3>
          <p>
             Poți solicita limitarea modului în care folosim datele tale în anumite situații.
              </p>

          <h3>8.5. Dreptul la Portabilitate</h3>
          <p>
             Poți primi datele tale într-un format structurat, utilizat în mod curent și care poate fi citit automat.
              </p>

          <h3>8.6. Dreptul la Opoziție</h3>
          <p>
             Poți obiecta la prelucrarea datelor tale în anumite scopuri (ex: marketing direct).
              </p>

          <h3>8.7. Cum Îți Exerciți Drepturile</h3>
          <p>
             Pentru a-ți exercita oricare dintre aceste drepturi, contactează-ne la:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@brain-event.com</li>
                <li><strong>Telefon:</strong> +40 767 978 707</li>
              </ul>
          <p>
             Vom răspunde cererii tale în termen de <strong>maximum 30 de zile</strong>.
              </p>
          <h2>9. Securitatea Datelor</h2>
          <p>
             Implementăm măsuri tehnice și organizatorice adecvate pentru a proteja datele tale împotriva 
                accesului neautorizat, pierderii, distrugerii sau modificării:
              </p>
              <ul>
                <li>Criptare SSL/TLS pentru transmiterea datelor</li>
                <li>Servere securizate și monitorizate</li>
                <li>Acces restricționat la datele personale (doar personal autorizat)</li>
                <li>Backup-uri regulate</li>
                <li>Proceduri de răspuns la incidente de securitate</li>
              </ul>
          <p>
             În cazul unei breșe de securitate care afectează datele tale, te vom notifica în termen de 
                72 de ore, conform GDPR.
              </p>
          <h2>10. Cookie-uri și Tehnologii Similare</h2>
          <p>
             Website-ul nostru folosește cookie-uri pentru a îmbunătăți experiența ta. Pentru detalii complete, 
                vezi <a href="/politica-cookies">Politica de Cookies</a>.
              </p>

          <h3>10.1. Microsoft Clarity și Microsoft Advertising</h3>
          <p>
            Colaborăm cu <strong>Microsoft Clarity</strong> și <strong>Microsoft Advertising</strong> pentru a
            înregistra modul în care utilizezi și interacționezi cu website-urile noastre, prin indicatori
            comportamentali, hărți termice (heatmaps) și redări de sesiuni (session replay), în scopul îmbunătățirii
            și promovării produselor și serviciilor Brain Event. Datele despre utilizarea site-ului pot fi colectate
            folosind cookie-uri de prima parte și terță parte și alte tehnologii de urmărire, pentru a evalua
            interesul pentru conținut și servicii și activitatea online. Folosim aceste informații și pentru
            optimizarea site-ului, pentru măsuri de securitate și limitarea fraudei/abuzurilor, precum și pentru
            publicitate, în măsura permisă de consimțământul tău (inclusiv prin banner-ul de cookie-uri) și de
            legislația aplicabilă. Pentru detalii despre modul în care Microsoft colectează și folosește datele,
            consultă{' '}
            <a href="https://privacy.microsoft.com/privacystatement" target="_blank" rel="noopener noreferrer">
              Microsoft Privacy Statement
            </a>
            .
          </p>
          <p>
            Îmbunătățim produsele și comunicarea noastră folosind Microsoft Clarity pentru a înțelege cum utilizezi
            site-ul. Atunci când continui să folosești site-ul după ce ai acceptat cookie-urile relevante, înțelegi
            că noi și Microsoft putem colecta și folosi aceste date în condițiile descrise aici și în{' '}
            <a href="/politica-cookies">Politica de Cookies</a>. Dacă refuzi aceste cookie-uri, utilizarea Clarity
            pentru analiză în formă extinsă nu va fi activată în mod corespunzător.
          </p>

          <h2>11. Minori</h2>
          <p>
             Serviciile noastre nu sunt destinate persoanelor sub 18 ani. Nu colectăm în mod conștient date 
                personale de la minori fără acordul părinților sau tutorilor legali.
              </p>
          <p>
             Dacă ai sub 18 ani, te rugăm să soliciți unui părinte sau tutore legal să achiziționeze biletul 
                în numele tău.
              </p>
          <h2>12. Modificări ale Politicii</h2>
          <p>
             Ne rezervăm dreptul de a actualiza această politică periodic. Orice modificare substanțială va fi 
                comunicată prin email sau prin notificare pe website.
              </p>
          <p>
             Te încurajăm să consulți această pagină regulat pentru a fi la curent cu practicile noastre de 
                protecție a datelor.
              </p>
          <h2>13. Plângeri și Autoritatea de Supraveghere</h2>
          <p>
             Dacă consideri că drepturile tale GDPR au fost încălcate, poți depune o plângere la:
              </p>
          <p>
             <strong>Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong>
              </p>
              <ul>
                <li><strong>Adresă:</strong> B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București</li>
                <li><strong>Telefon:</strong> +40 318 059 211</li>
                <li><strong>Email:</strong> anspdcp@dataprotection.ro</li>
                <li><strong>Website:</strong> <a href="https://www.dataprotection.ro" target="_blank" rel="noopener noreferrer">www.dataprotection.ro</a></li>
              </ul>
          <p>
             Totuși, te încurajăm să ne contactezi mai întâi pentru a rezolva orice problemă.
              </p>
          <h2>14. Contact</h2>
          <p>
             Pentru orice întrebări despre această politică de confidențialitate sau despre modul în care 
                prelucrăm datele tale:
              </p>
              <ul>
                <li><strong>Email:</strong> contact@brain-event.com</li>
                <li><strong>Telefon:</strong> +40 767 978 707</li>
                <li><strong>Adresă:</strong> București, România</li>
              </ul>
          <div className="legal-footer">
            <p>
              Confidențialitatea și securitatea datelor tale sunt prioritare pentru noi. Mulțumim pentru încredere!
            </p>
          </div>
          </div>
        </div>

      <Footer />
    </>
  );
}

export default PrivacyPage;

